export default defineNuxtRouteMiddleware(async (to, from) => {
  // These pages have chatbot enabled by default
  const chatbotRoutes: (string | RegExp)[] = [
    /^\/property\/.*/, // Match any route starting with /property/
    /^\/neighborhood\/.*/, // Match any route starting with /neighborhood/
    /^\/cities\/.*/, // Match any route starting with /cities/
    '/compare',
    '/concierge',
    // "/property-search",
    "/planning",
  ];

  // skip middleware on server
  if (import.meta.server) return;

  const { $toggleChatbot } = useNuxtApp();

  const matchesRoute = chatbotRoutes.some((route) => {
    if (typeof route === "string") {
      return to.path === route;
    } else if (route instanceof RegExp) {
      return route.test(to.path);
    }
    return false;
  });

  if (!matchesRoute) {
    $toggleChatbot(false);
  } else {
    $toggleChatbot(true);
  }

  return;
});
